import { z } from "zod";

export const formSchema = z.object({
    incomingPostback: z.string(),
});

export type ModifyPostbackIncomingFormData = z.infer<typeof formSchema>;
